import type { FC } from "react";

import { Badge, type BadgeProps, Icon, Text } from "@alpacahq/ui/old";

export type RelationshipInfoProps = {
  type: "ACH" | "Wire" | "CurrencyCloud";
  logo?: string;
  bankName: string;
  accountName: string;
  status?: {
    text: string;
    variant: BadgeProps["variant"];
  };
};

export const RelationshipInfo: FC<RelationshipInfoProps> = ({
  logo,
  bankName,
  status,
  accountName,
}) => (
  <div className="flex items-start justify-between">
    <div>
      <div className="flex items-center justify-start gap-4">
        <div className="h-7 w-7 overflow-hidden rounded-full border-1 border-gray-200">
          {logo ? (
            <img src={logo} alt={bankName} />
          ) : (
            <Icon name="BuildingLibrary" size="xl" />
          )}
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between gap-2">
            <Text className="font-semibold text-md">{bankName}</Text>
            {status && (
              <Badge className="text-xs" variant={status.variant}>
                {status.text}
              </Badge>
            )}
          </div>

          <Text className="text-sm">{accountName}</Text>
        </div>
      </div>
    </div>
  </div>
);
